export default __webpack_public_path__ + "static/80-dac0fc8eb21c6ca4885f70f9469fbc80.jpg";